import { ROUTE_CONST } from "~/route/const";
import { getPOI } from "~/route/utils";

// @ts-nocheck
/* eslint-disable */
Mapy.Route = {};

Mapy.Route.ContextItem = function(label, route, destination) {
	SMap.Control.ContextMenu.Item.call(this, label);
	this._destination = destination;
};

Mapy.Route.ContextItem.prototype = Object.create(Object.assign({}, SMap.Control.ContextMenu.Item.prototype));

Mapy.Route.ContextItem.FROM = 0;
Mapy.Route.ContextItem.TO = 1;
Mapy.Route.ContextItem.CIRCUIT = 2;

Mapy.Route.ContextItem.prototype.click = function(e, menu) {
	if (this._disabled) { return; }

	var route = Mapy.getComponent("route");

	getPOI(this._coords, true).then(data => {
		let routeState = Mapy.CML.state.route;
		let clean = false;
		let newRouteState = {
			route: {
				zoom: false,
				items: routeState?.items || [],
			}
		};

		switch (this._destination) {
			case Mapy.Route.ContextItem.FROM:
				newRouteState.route.items.unshift(Object.assign({}, data, {
					position: ROUTE_CONST.position.start,
					favoriteId: "",
					usertitle: "",
				}));
				break;

			case Mapy.Route.ContextItem.TO:
				data.position = ROUTE_CONST.position.end;
				newRouteState.route.items.push(Object.assign({}, data, {
					position: ROUTE_CONST.position.end,
					favoriteId: "",
					usertitle: "",
				}));
				break;

			case Mapy.Route.ContextItem.CIRCUIT:
				data.planTrip = true;
				newRouteState.route.items = [data];
				newRouteState.route.params = {
					tripCriterion: ROUTE_CONST.circuitTypes.trial.criterion[0],
					type: ROUTE_CONST.TYPE_WALK,
					favoriteId: "",
					usertitle: "",
				};
				newRouteState.route.zoom = true;
				clean = true;
				break;
		}

		if (!route.isActive()) {
			route.activate().then(() => {
				const promise = clean ? route.clear({
					params: Object.assign(Mapy.CML.state.route.params, { waypoints: "" })
				}) : Promise.resolve();
				promise.finally(() => {
					Mapy.CML.state = newRouteState;
					Mapy.getComponent("history").save();
				});
			}, () => {});
		} else {
			Mapy.CML.state = newRouteState;
			Mapy.getComponent("history").save();
		}

	}, () => {});

	menu.close();
}
